import { callAPi } from './http-common';

const add = (data) => {
  return callAPi.post('/seo/addSubCategorytoSeo', data);
};
const get = () => {
  return callAPi.get('/seo/getAllSubCate');
};
const getbyid = (id) => {
  return callAPi.get(`/seo/getSubCate/${id}`);
};
const update = (id, data) => {
  return callAPi.patch(`/seo/updateSubCate/${id}`, data);
};
const deletes = (id) => {
  return callAPi.delete(`/seo/deleteSubCate/${id}`);
};
const ChildCategorySEO = {
  add,
  get,
  update,
  deletes,
  getbyid,
};

export default ChildCategorySEO;